import {
	type UseMutationOptions,
	useMutation,
	useQueryClient
} from '@tanstack/react-query'
import { httpClaimFinalReviewListing } from '@/features/luxe-submissions/http/luxe-submissions.http'
import { errorHandler } from '@/helpers/utils'
import { FINAL_REVIEW_LISTING_DETAILS_QUERY_KEY } from './use-get-final-review-listing-details'
import { FINAL_REVIEW_LISTINGS_QUERY_KEY } from './use-get-final-review-listings'
import { QUEUE_COUNTS_QUERY_KEY } from './use-get-queue-counts'

export const useClaimFinalReviewListing = (
	options?: Omit<UseMutationOptions<unknown, unknown, string[]>, 'mutationFn'>
) => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (listingIds) => httpClaimFinalReviewListing(listingIds),
		...options,
		onError: (error, variables, onMutateResult, context) => {
			errorHandler(error)
			options?.onError?.(error, variables, onMutateResult, context)
		},
		onSuccess: (...args) => {
			options?.onSuccess?.(...args)

			queryClient.invalidateQueries({
				queryKey: [FINAL_REVIEW_LISTINGS_QUERY_KEY]
			})
			queryClient.invalidateQueries({
				queryKey: [FINAL_REVIEW_LISTING_DETAILS_QUERY_KEY]
			})
			queryClient.invalidateQueries({
				queryKey: [QUEUE_COUNTS_QUERY_KEY]
			})
		}
	})
}
